<div class="sheba-best-hospital-background relative flex w-full max-w-7xl flex-col px-4 pb-14 md:pb-[8.25rem]">
  <div class="z-[2] -mb-[4.34rem] flex place-content-center">
    <sheba-hero-icon />
  </div>

  <div
    class="mx-auto flex min-h-[20.8125rem] w-full max-w-[76.4375rem] flex-col place-content-start place-items-center gap-3 whitespace-pre-line rounded-2xl bg-[#010965] px-6 pt-20 text-center max-md:pb-8 md:h-[18.5rem] md:place-content-center md:pt-10 dark:bg-transparent"
  >
    <span
      class="max-w-[45rem] whitespace-break-spaces text-[2.5rem] font-black leading-[2.875rem] text-[#D9F6EF] md:text-[2.875rem] md:font-bold"
    >
      {{ bestHospitalBannerTitle() }}
    </span>
    <span class="text-[1.75rem] font-normal leading-[2.375rem] text-[#D9F6EF]">
      {{ bestHospitalBannerDescription() }}
    </span>
  </div>
</div>
